import Formsy from 'formsy-react';
import React from 'react';
import { Row, Column, Button, Colors } from 'react-foundation';
import { Reveal } from 'react-foundation-components/lib/global/reveal';
import { connect } from 'react-redux';
import { Input } from 'formsy-react-components';
import { push } from 'react-router-redux';
import { CloseModal } from '../layout/close-modal';
import {
  login,
  loadUser,
  forgotPassword,
  showLoginModal
} from '../../state/auth/actions';

var SignInComponent = React.createClass({
  getInitialState() {
    return {
      canSubmit: false,
      action: 'login'
    };
  },

  componentWillUnmount() {
    this.unMounting = true;
  },

  enableButton() {
    this.setState({
      canSubmit: true
    });
  },

  disableButton() {
    this.setState({
      canSubmit: false
    });
  },

  setAction(action) {
    this.setState({ action });
  },

  handleHide() {
    this.props.dispatch(showLoginModal(false));
  },

  submit(formData) {
    this.setState({
      submitting: true
    });

    this.props.onSubmit(formData.email, formData.password).then(() => {
      if (!this.unMounting) {
        this.setState({
          submitting: false
        });
      }
    });
  },

  render() {
    return (
      <a
        id="login-link"
        onClick={() => {
          this.props.dispatch(showLoginModal(true));
        }}
      >
        Sign in
        <Reveal
          onHide={this.handleHide}
          size="tiny"
          show={this.props.showModal}
          className="login-modal"
        >
          <CloseModal onHide={this.handleHide} />
          <div className="modal-header">
            <Row>
              <Column small={12} className="text-center">
                <h3 className="text-primary">
                  <strong>
                    {this.state.action === 'login'
                      ? 'Sign In'
                      : 'Forgot Password'}
                  </strong>
                </h3>
              </Column>
            </Row>
          </div>
          <hr />
          <div className="modal-form">
            <Formsy.Form
              onValidSubmit={this.submit}
              onValid={this.enableButton}
              onInvalid={this.disableButton}
            >
              <Row>
                <Column small={12} large={8} centerOnSmall>
                  <Input
                    label="Email"
                    type="email"
                    name="email"
                    value=""
                    validations="isEmail"
                    labelClassName="small-12"
                    elementWrapperClassName="small-12"
                    placeholder="Enter your email..."
                    required
                  />
                </Column>
              </Row>
              {this.state.action === 'login' ? (
                <Row>
                  <Column small={12} large={8} centerOnSmall>
                    <Input
                      label="Password"
                      type="password"
                      name="password"
                      value=""
                      labelClassName="small-12"
                      elementWrapperClassName="small-12"
                      placeholder="Enter your password..."
                      required
                    />
                  </Column>
                </Row>
              ) : (
                ''
              )}
              <Row>
                <Column small={12} large={8} centerOnSmall>
                  {this.state.action === 'login' ? (
                    <div className="text-red text-left">
                      {this.props.loginError}
                    </div>
                  ) : (
                    <div className={this.props.passwordState.get('msgClass')}>
                      {this.props.passwordState.get('msg')}
                    </div>
                  )}
                </Column>
              </Row>
              <Row>
                <Column small={12} large={8} offsetOnLarge={2}>
                  <Button
                    className="login-button"
                    color={Colors.PRIMARY}
                    type="submit"
                    disabled={!this.state.canSubmit}
                    isExpanded
                  >
                    {this.state.action === 'login'
                      ? 'Sign In'
                      : 'Forgot Password'}
                  </Button>
                  <p className="pull-right">
                    {this.state.action === 'login' ? (
                      <a
                        className="go-to-forgot-password"
                        onClick={() => this.setAction('forgot password')}
                      >
                        Forgot password?
                      </a>
                    ) : (
                      <a
                        className="go-to-login"
                        onClick={() => this.setAction('login')}
                      >
                        Back to login
                      </a>
                    )}
                  </p>
                </Column>
              </Row>
            </Formsy.Form>
          </div>
        </Reveal>
      </a>
    );
  }
});

const mapStateToProps = state => ({
  isAuthenticated: state.auth.get('isAuthenticated'),
  loginError: state.auth.get('loginError'),
  isLoading: state.auth.getIn(['session', 'isLoading']),
  passwordState: state.auth.get('passwordState'),
  showModal: state.auth.get('showLoginModal')
});

const mapDispatchToProps = dispatch => ({
  onSubmit: (email, password) => {
    if (password) {
      return dispatch(login(email, password)).then(response => {
        if (response.ok) {
          dispatch(loadUser());
          dispatch(push('/'));
        }
      });
    } else {
      return dispatch(forgotPassword(email));
    }
  },
  dispatch
});

var SignInModal = connect(mapStateToProps, mapDispatchToProps)(SignInComponent);

export default SignInModal;



/** WEBPACK FOOTER **
 ** ./src/components/login/login.jsx
 **/